import { FC } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
} from '@chakra-ui/react';

type Props = {
  expired: string;
};

/**
 * 編集モーダル用の Zeus Token ステータスフォーム(readonly)です。
 */
export const ZeusTokenExpiredForm: FC<Props> = ({ expired }) => (
  <FormControl>
    <SimpleGrid templateColumns="1fr 2fr">
      <Box pl="40px">
        <FormLabel>- ステータス</FormLabel>
      </Box>
      <Input value={expired} disabled />
    </SimpleGrid>
  </FormControl>
);
